import React from "react";
export default function ResourcesPage() {
  return (
    <div style={{ padding: "2rem" }}>
      {" "}
      <h2>Resources</h2> <p>Guides, articles, and references (dummy).</p>{" "}
    </div>
  );
}
